<template>
  <div
    class="main--text">
    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
      disable-resize-watcher
      >
      <v-list>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          @click="transit(item)"
        >
          <v-list-item-content>
            <v-list-item-title
              class="font-weight-light subheading">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      color="primary"
      dark
      app>
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        />
      <v-toolbar-title class="title--text">Prosense</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            dark
            color="primary"
            v-on="on"
          >
            <v-icon>far fa-question-circle</v-icon>
          </v-btn>
        </template>
        <span>
          ヘルプ
        </span>
      </v-tooltip> -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
            @click="$emit('sign-out-button-click')"
          >
            <v-icon>fa-door-open</v-icon>
          </v-btn>
        </template>
        <span>
        ログアウト
        </span>
      </v-tooltip>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      items: [
        // { title: "ユーザー情報" , name: "parentProfile"},
        // { title: "お子さま情報", name: "students" },
        // { title: "メッセージ", name: "parentMessages"},
        // { title: "先生を探す", name: "searchTeachers" },
        // { title: "リクエスト", name: "parentRequests"},
        // { title: "授業の応募", name: "parentOffers"} ,
        // { title: "授業一覧", name: "parentLessons"},
        { title: "オンラインエディタ", name: "parentEditors"}
      ]
    }
  },
  methods: {
    transit: function(item) {
      this.drawer = !this.drawer
      const uuid = this.$store.getters.parent.uuid
      this.$router.push({
        name: item.name,
        params: { id: uuid }
      })
    }
  }
}
</script>
